var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-comp"},_vm._l((_vm.newData),function(item,index){return _c('ElementForm',{key:index,staticClass:"form",attrs:{"form":item},on:{"onAttr":function($event){_vm.onAttr($event, item, index)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616ca87d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMTable/components/filterComp/index.vue
// module id = null
// module chunks = 